import { DIMENSIONS } from 'shared/constants/theme';

export const HALF_OF_CONTAINER_INNER_WIDTH =
  DIMENSIONS.CONTAINER_INNER_WIDTH / 2; // in px

export const THIRD_OF_CONTAINER_INNER_WIDTH =
  DIMENSIONS.CONTAINER_INNER_WIDTH / 3; // in px

export const SHIFT_VERTICAL_MARGIN_TOP = 120; // in px
